module.exports = __webpack_public_path__ + "static/img/robot-x2.6afda8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/robot-x2.png
// module id = gfOr
// module chunks = 1